import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { lockIcon, sendIcon } from '@europrocurement/l2d-icons';
import { FlexyButton } from '@europrocurement/flexy-components';

export type InvoicePaymentProps = {
    amount: number;
    isFacture?: boolean;
    onClickDemandeReglement?: () => void;
    onClickPaiement?: () => void;
};

const InvoicePayment: React.FunctionComponent<InvoicePaymentProps> = function ({
    amount,
    onClickDemandeReglement,
    onClickPaiement,
    isFacture = false,
}) {
    const { palette } = useTheme();

    const wrapperInvoicePaymentSx = {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    };

    const labelSx = {
        fontSize: '15px',
        fontWeight: '600',
        lineHeight: '21px',
    };

    const amountLabelSx = {
        fontSize: '22px',
        fontWeight: '600',
        lineHeight: '26.4px',
    };

    const wrapperSx = {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        justifyContent: 'space-between',
        marginTop: '16px',
    };

    return isFacture ? (
        <Box sx={wrapperSx}>
            <Box
                sx={wrapperInvoicePaymentSx}
                data-testid="invoice-payment"
            >
                <Typography sx={labelSx}>Montant (TTC) à payer</Typography>

                <Typography sx={amountLabelSx}>
                    {(Math.floor(amount * 100) / 100).toFixed(2)}&euro;
                </Typography>
            </Box>
            <Box sx={wrapperInvoicePaymentSx}>
                {onClickDemandeReglement && amount > 0 ? (
                    <FlexyButton
                        label="Demander le règlement"
                        icon={sendIcon}
                        variant="outlined"
                        color={palette.primary.dark}
                        onClick={() => onClickDemandeReglement()}
                    />
                ) : null}
                {onClickPaiement && amount > 0 ? (
                    <FlexyButton
                        label="Procéder au paiement"
                        icon={lockIcon}
                        variant="contained"
                        color={palette.primary.dark}
                        onClick={() => onClickPaiement()}
                    />
                ) : null}
            </Box>
        </Box>
    ) : null;
};

export default InvoicePayment;
